import { handleActions } from 'redux-actions';
import { fetchPrivilegesSuccess } from '../actions/privileges';

const defaultState = {};

export default handleActions<any, any>(
  {
    [fetchPrivilegesSuccess.toString()]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
  defaultState
);
